import { createReducer, on } from '@ngrx/store';
import { AuthState } from '../models/auth-state.interface';
import * as AuthActions from '../actions/auth.actions';

export const initialState: AuthState = {
  error: null,
  userInfo: null,
  token: null,
  refreshToken: null,
  loginProcess: false,
  permissions: [],
  sharedOrganizations: [],
  hasInit2FA: null,
  hasVerify2FA: false,
  loadingOtpInitData: false,
  loadingUpdateProfileData: false,
  disabling2FA: false,
};

export const authReducer = createReducer(
  initialState,

  on(AuthActions.setToken, (state, { token }) => ({
    ...state,
    token,
  })),
  on(AuthActions.setRefreshToken, (state, { refreshToken }) => ({
    ...state,
    refreshToken,
  })),
  on(AuthActions.setUserInfo, (state, { userInfo }) => ({
    ...state,
    userInfo: {
      ...state.userInfo,
      ...userInfo,
    },
  })),

  on(AuthActions.login, (state) => ({
    ...state,
    error: null,
    loginProcess: true,
  })),
  on(AuthActions.loginSuccess, (state) => ({
    ...state,
    loginProcess: false,
  })),
  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    error,
    loginProcess: false,
  })),

  on(AuthActions.updateProfile, (state) => ({
    ...state,
    loadingUpdateProfile: true,
  })),

  on(
    AuthActions.updateProfileSuccess,
    AuthActions.updateProfileFailure,
    (state) => ({
    ...state,
    loadingUpdateProfile: false,
  })),

  on(
    AuthActions.setPermissions,
    AuthActions.updatePermissionsSuccess,
    (state, { permissions }) => ({
    ...state,
    permissions,
  })),

  on(AuthActions.setSharedOrgs, (state, { sharedOrganizations }) => ({
    ...state,
    sharedOrganizations,
  })),

  on(AuthActions.loginNeeds2FAInit, (state, { secret, qr }) => ({
    ...state,
    hasInit2FA: { secret, qr },
  })),

  on(AuthActions.loginNeeds2FAVerification, (state) => ({
    ...state,
    hasInit2FA: null,
    hasVerify2FA: true,
  })),

  on(AuthActions.getOtpInitData, (state) => ({
    ...state,
    loadingOtpInitData: true,
  })),
  on(
    AuthActions.getOtpInitDataSuccess,
    (state, data) => ({
      ...state,
      hasInit2FA: data,
      loadingOtpInitData: false,
    }),
  ),

  on(
    AuthActions.getOtpInitDataFailure,
    (state) => ({
      ...state,
      hasInit2FA: null,
      loadingOtpInitData: false,
    }),
  ),

  on(AuthActions.disable2FA, (state) => ({
    ...state,
    disabling2FA: true,
  })),
  on(
    AuthActions.disable2FASuccess,
    AuthActions.disable2FAFailure,
    (state) => ({
      ...state,
      disabling2FA: false,
    }),
  ),
  on(AuthActions.reset, () => ({
    ...initialState,
  })),
);
